export default "__VITE_ASSET__4b5d6147__"